<div class="preloader">
    <div class="loader">
        <img
            src="assets/img/OptebizImage/favicon-leanqubitbr.webp"
            alt="LeanQubit Logo"
            class="logo-spinner"
            loading="lazy"
        />
    </div>
</div>
